module.exports = {
	init: function(){
		this.loghandler(this);
		this.checkAgreement();
	},
	checkAgreement: function(){
		var $ele = $('.js_checkAgreement'),
		    $submit = $ele.parents('form').find('[type=submit]'),
		    checked = $ele.prop('checked');
		if(checked){
			$submit.removeClass('is_disabled').prop("disabled", false);
		}else{
			$submit.addClass('is_disabled').prop("disabled", true);
		}
	},
	loghandler: function(e){
		$('.js_checkAgreement').change(function(){
			e.checkAgreement();
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/form.js
// module id = 4
// module chunks = 0